// components/SubmissionSuccess.jsx - Success Screen After Submission
import React from 'react'
import { CheckCircle, Plus, WifiOff, Clock } from 'lucide-react'

export default function SubmissionSuccess({ formLink, onNewSubmission, isOffline }) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="card max-w-md w-full text-center">
        {/* Success Icon */}
        <div className={`w-20 h-20 mx-auto rounded-full flex items-center justify-center ${
          isOffline ? 'bg-yellow-100' : 'bg-green-100'
        }`}>
          {isOffline ? (
            <Clock className="w-10 h-10 text-yellow-600" />
          ) : (
            <CheckCircle className="w-10 h-10 text-green-600" />
          )}
        </div>
        
        {/* Message */}
        <h2 className="text-2xl font-semibold mt-6 text-gray-900">
          {isOffline ? 'Saved Locally' : 'Record Submitted!'}
        </h2>
        
        <p className="text-gray-600 mt-2">
          {isOffline ? (
            <>
              Your application record has been saved locally and will be 
              submitted automatically when you're back online.
            </>
          ) : (
            <>
              Your pesticide application record has been saved to your 
              Google Sheet for Oregon compliance.
            </>
          )}
        </p>
        
        {/* Job Info */}
        <div className="mt-6 p-4 bg-gray-50 rounded-lg text-sm text-left">
          <div className="flex justify-between">
            <span className="text-gray-500">Job #</span>
            <span className="font-medium">{formLink?.jobNumber}</span>
          </div>
          <div className="flex justify-between mt-2">
            <span className="text-gray-500">Customer</span>
            <span className="font-medium">{formLink?.clientName}</span>
          </div>
        </div>
        
        {/* Offline warning */}
        {isOffline && (
          <div className="mt-4 p-3 bg-yellow-50 rounded-lg border border-yellow-200 
                          flex items-center gap-2 text-sm text-yellow-800">
            <WifiOff className="w-5 h-5 flex-shrink-0" />
            <span>You're currently offline. Data will sync when connected.</span>
          </div>
        )}
        
        {/* Actions */}
        <div className="mt-8 space-y-3">
          <button
            onClick={onNewSubmission}
            className="btn-primary w-full flex items-center justify-center gap-2"
          >
            <Plus className="w-5 h-5" />
            New Application Record
          </button>
          
          <p className="text-xs text-gray-500">
            Use this to record multiple applications on the same job
          </p>
        </div>
      </div>
    </div>
  )
}
